module.exports = __webpack_public_path__ + "img/H-63-ER-1000-BB.a9fea46c.png";